import plusIcon from "../../assets/plusIconWhite20.svg";
import searchIcon from "../../assets/searchIcon20.svg";
import filterIcon from "../../assets/baseFilterIcon20.svg";
import clearIcon from "../../assets/xIcon20.svg";

import useBulkTesting from "../../hooks/useBulkTesting";
import { useState } from "react";
import AddGenerateActualAnswerModal from "./AddGenerateAcutalAnswerModal";
import FilterModal from "./FilterModal";

const ActionGenerateActualAnswer = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [isAddBulkTestOpen, setIsAddBulkTestOpen] = useState(false);

  const {
    selectedActualAnswerFilters,
    getActualAnswers,
  } = useBulkTesting();

  return (
    <div className="bulk-testing__action-container">
      {/* <div style={{ position: 'relative' }}>
        <input type="text" placeholder="Search by ID" className="bulk-search" value={searchActualAnswer} onChange={(e) => setSearchActualAnswer(e.target.value)} />
        {searchActualAnswer
          ? <img src={clearIcon} alt="search icon" className="bulk-search__icon" onClick={() => setSearchActualAnswer('')} />
          : <img src={searchIcon} alt="search icon" className="bulk-search__icon" />
        }
      </div> */}
      <div className="bulk-filter">
        <button onClick={() => setIsFilterOpen(true)} className="btn-base with-icon font-base">
          <img
            src={filterIcon}
            alt="filter icon"
            className="filter-button-icon"
          />
          Filter
        </button>
        <FilterModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} />
      </div>
      <button onClick={() => setIsAddBulkTestOpen(true)} className="btn-primary with-icon font-primary" >
        <img
          src={plusIcon}
          alt="filter icon"
          className="filter-button-icon"
        />
        Generate Actual Answer
      </button>
      <AddGenerateActualAnswerModal
        isOpen={isAddBulkTestOpen}
        onClose={() => setIsAddBulkTestOpen(false)}
        onSuccess={() => getActualAnswers(selectedActualAnswerFilters)}
      />
    </div>
  )
}

export default ActionGenerateActualAnswer;